import React, { FC, useEffect } from 'react';
import { observer } from 'mobx-react';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';
import { PASSENGERS_PARKING_LANDING_PAGE_ID } from '../../../../shared/api/contentful/constants';
import { getDefaultValuesForBooking } from '../../booking-steps/details/hooks/useDefaultValues';
import { useHandleSubmitPartialAmend } from '../../booking-steps/details/hooks/useHandleSubmitPartialAmend';
import { useBookingForUrlQuery } from '../../booking/useBookingForUrlQuery';
import { Details } from '../../booking-steps/details/Details';
import { useUrlForPageId } from '../../../../app/pages/ui/utils/useUrlForPageId';
import { BookingPageLayout } from '../shared/BookingPageLayout';
import { useCreateEmailSuggestionStore } from '../../../domain/email-validation/stores/useCreateEmailSuggestionStore';
import { useNavigate } from '../../../../shared/router/useNavigate';

export const PartialAmendDetailsPage: FC = observer(() => {
	const { t } = useTranslation();
	const landingPageUrl = useUrlForPageId(PASSENGERS_PARKING_LANDING_PAGE_ID);
	const { booking, isLoading } = useBookingForUrlQuery();
	const { handleSubmit, error } = useHandleSubmitPartialAmend(
		booking,
		landingPageUrl,
	);
	const defaultValues = booking && getDefaultValuesForBooking(booking);
	const emailSuggestionStore = useCreateEmailSuggestionStore();
	const navigate = useNavigate();

	useEffect(() => {
		if (!isLoading && !booking) {
			navigate(landingPageUrl);
		}
	}, [booking, isLoading]);

	return (
		<BookingPageLayout
			parentTitle={t('web_parking_modify_personal_details_back_button')}
			parentUrl={landingPageUrl}
			title={t('web_parking_modify_personal_details_header')}
		>
			<Details
				defaultValues={defaultValues}
				submitButtonText={t(
					'web_parking_modify_personal_details_submit_button',
				)}
				finalSubmitHandler={handleSubmit}
				submitError={error}
				emailSuggestionStore={emailSuggestionStore}
				hasHiddenConsentCheckbox
				hasHiddenRememberDetailsCheckbox
				modifyBooking
			/>
		</BookingPageLayout>
	);
});
